module.exports = __webpack_public_path__ + "static/media/new_tag.79e54095.png";